import React, { useEffect, useState } from "react";
import styles from "./splash.module.css";

import { IntegrationDetail } from "../../../models/topic-detail.entity";
import Button from "../../../components/Button/Button";
import { useStyles } from "../../../../providers/styles/use-styles";

interface Props {
  gameInfo: IntegrationDetail;
  onStarted: () => void;
}

const Splash = ({ gameInfo, onStarted }: Props) => {
  const [loading, setLoading] = useState(false);
  const { getStyles } = useStyles();

  function startedSoonTitle() {
    if (gameInfo.start_date) {
      try {
        const date = new Date(gameInfo.start_date);

        if (isNaN(date.getTime())) {
          throw new Error('Invalid date');
        }

        const timeString = date.toLocaleTimeString('ru-RU', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        return `Викторина начнется ${date.toLocaleDateString()} в ${timeString}`
      } catch (error) {
        console.error('Error parsing date:', error);
        return 'Викторина скоро начнется!'
      }
    } else {
      return 'Викторина скоро начнется!'
    }
  }

  function finishedTitle() {
    return 'Викторина уже закончилась!'
  }

  return (
    <div className={styles.main}>
      <img
        className={styles.banner}
        src={gameInfo.image_url}
        alt={gameInfo.name}
      />

      <div className={styles.content}>

        <div className={styles.wrapper}>

          <h3
            className={styles.title}
            style={getStyles(["txt_label_primary_base"])}
          >
            {gameInfo.name}
          </h3>
          <p
            className={styles.description}
            style={getStyles(["txt_label_secondary_base"])}
          >
            {gameInfo.description}
          </p>
          {gameInfo.sponsor && (
            <img
              className={styles.logo}
              src={gameInfo.sponsor.logo_url}
              alt={gameInfo.sponsor.name}
              height={40}
            />
          )}
        </div>

        {gameInfo.is_open ? (
          <Button
            title="ИГРАТЬ"
            onClick={() => {
              setLoading(true);
              onStarted();
            }}
            isLoading={loading}
          />
        ) : (
          <p
            className={styles.description}
            style={getStyles(["txt_label_secondary_base"])}
          >
            {gameInfo.is_finished ? finishedTitle() : startedSoonTitle()}
          </p>
        )}
      </div>
    </div>
  );
};

export default Splash;
